var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chat-messages" } },
    [
      !_vm.messageSyncRunning
        ? _c("MessageList", {
            attrs: {
              "always-scroll-to-bottom": true,
              colors: _vm.colors,
              "is-colored": true,
              ischatwindow: true,
              messages: _vm.messages,
              participants: _vm.getParticipants(),
              "scroll-top": false,
              "is-whatsapp": !!_vm.contact.lastConversation.whatsappNumber,
              "channel-id": _vm.contact.lastConversation.channel,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }